<form id="voucher-block" class="form-control-wrapper form-width-52" [formGroup]="voucherInputFormGroup">
    <mat-form-field hideRequiredMarker>
        <mat-label>{{ 'PARTY.CASHIER.web.deposit.flash1voucher.voucher.label' | translate }}</mat-label>
        <input
            matInput
            digitOnly
            type="tel"
            formControlName="voucherInput"
            id="voucherInput"
            pattern="[0-9]*"
            [(ngModel)]="depositService.depositInfo.paymentAccountInfo.voucherNumber"
            minlength="16"
            maxlength="16"
            placeholder="{{ 'PARTY.CASHIER.web.deposit.flash1voucher.voucher.label' | translate }}"
            (keypress)="numberOnly($event)"
            (input)="validateVoucherInput()"
            validNumber />
        @if (
            voucherInputFormGroup &&
            voucherInputFormGroup.controls['voucherInput'] &&
            (voucherInputFormGroup.controls['voucherInput'].invalid ||
                voucherInputFormGroup.controls['voucherInput'].touched ||
                voucherInputFormGroup.controls['voucherInput'].dirty)
        ) {
            <mat-error>
                @if (
                    voucherInputFormGroup.controls['voucherInput'].errors?.['required'] ||
                    voucherInputFormGroup.controls['voucherInput'].errors?.['minlength']
                ) {
                    <div>
                        {{ 'PARTY.CASHIER.web.deposit.flash1voucher.voucher.required' | translate }}
                    </div>
                }
            </mat-error>
        }
    </mat-form-field>
</form>
